import { cmToPx } from 'helpers/utils';
import style from './FenceElement.module.scss';

const FenceElementDoor = ({ element, slats }) => {
  let gridItemStyle;
  let supporterItemStyle;

  if (slats.railDirection === 'horizontal') {
    gridItemStyle = { height: slats.size };
    supporterItemStyle = { width: cmToPx(6) };
  } else {
    gridItemStyle = { width: slats.size };
    supporterItemStyle = { height: cmToPx(6) };
  }

  return (
    <div className={`${style.door} ${style['door-' + slats.railColor]}`} style={{ height: slats.railHeight }}>
      <div className={style.door_supporters} style={{ top: cmToPx(6), bottom: cmToPx(6) }}>
        <span style={supporterItemStyle}></span>
        <span style={supporterItemStyle}></span>
        {element.type === 'double' && <span style={supporterItemStyle}></span>}
        {element.type === 'double' && <span style={supporterItemStyle}></span>}
      </div>

      {element.type === 'simple' && slats.railHeight > 100 && (
        <div
          className={style.door_handle}
          style={{ bottom: cmToPx(77), left: cmToPx(2), width: cmToPx(8), height: cmToPx(8) }}
        >
          <span style={{ left: cmToPx(2), width: cmToPx(12), height: cmToPx(4) }}></span>
        </div>
      )}

      {element.type === 'simple' || slats.railDirection === 'horizontal' ? (
        <div
          className={style.door_grid}
          style={{ top: cmToPx(6), right: cmToPx(0), bottom: cmToPx(6), left: cmToPx(0) }}
        >
          {[...Array(slats.count)].map((slat, index) => (
            <span key={index} style={gridItemStyle}></span>
          ))}
        </div>
      ) : (
        <div
          className={`${style.door_grid} ${style['door_grid-double']}`}
          style={{ top: cmToPx(6), right: cmToPx(0), bottom: cmToPx(6), left: cmToPx(0) }}
        >
          <div>
            {[...Array(Math.floor(slats.count / 2))].map((slat, index) => (
              <span key={index} style={gridItemStyle}></span>
            ))}
          </div>
          <span style={{ width: cmToPx(8) }}></span>
          <div>
            {[...Array(Math.floor(slats.count / 2))].map((slat, index) => (
              <span key={index} style={gridItemStyle}></span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default FenceElementDoor;
